export class Ingredient {
    name: string;
    amount: number;
    //TODO: add pieces, grams...

    constructor(name, amount){
        this.name = name;
        this.amount = amount;
    }
}



// WEBPACK FOOTER //
// C:/gitHub/cookbook/src/app/components/shopping-list/ingredient.model.ts